import { render, staticRenderFns } from "./AppReviews.vue?vue&type=template&id=2049f30a&scoped=true&"
import script from "./AppReviews.vue?vue&type=script&lang=js&"
export * from "./AppReviews.vue?vue&type=script&lang=js&"
import style0 from "./AppReviews.vue?vue&type=style&index=0&id=2049f30a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049f30a",
  null
  
)

export default component.exports